import React from 'react';

import { valuesPropTypes } from '../filters/prop-types';
import SearchModalContent from './components/SearchModalContent';
import { getContentRenderer } from './utils/getRenderers';

/**
 * @typedef {Object} SearchModalContentContainerProps
 * @property {string} id - Identificador único del elemento (requerido)
 * @property {number} [results] - Número de resultados (opcional)
 * @property {string} [filterId] - Identificador del filtro (opcional)
 * @property {string} type - Tipo de modal (requerido)
 * @property {Array} values - Valores del modal (requerido)
 * @property {string} title - Título del modal (requerido)
 * @property {Object?} [labels] - Etiquetas del modal (opcional)
 * @property {Object} multi_selection - Configuración de selección múltiple (requerido)
 */

/**
 * Componente que renderiza el contenido del modal de búsqueda.
 * @param {SearchModalContentContainerProps} props - Propiedades del componente.
 * @returns {React.ReactNode} - Componente renderizado.
 */

const SearchModalContentContainer = (props) => (
  <SearchModalContent {...props} contentRenderer={getContentRenderer(props)} />
);

SearchModalContentContainer.propTypes = {
  ...valuesPropTypes,
};

export default SearchModalContentContainer;
